import cx from "classnames";
import { useEffect, useState } from "react";
import Media from "react-media";
import { connect } from "react-redux";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import { ResponsiveScreenSizes, TabTypes } from "../../../../utils/const";
import EventsScreenHeaderMobile from "../../../EventsScreen/components/EventsScreenHeader/layouts/HeaderLayoutMobile/HeaderLayoutMobile";
import "./AsianEventsScreenHeader.scss";
import EventsScreenHeaderDesktop from "./layouts/AsianHeaderLayoutDesktop/AsianHeaderLayoutDesktop";

type Props = {
  callback: (...args: Array<any>) => any;
  onClickBookmarks: (...args: Array<any>) => any;
  onClickFavourites: (...args: Array<any>) => any;
  bookmarksActive: boolean;
  favouritesActive: boolean;
  favouritesOnly: boolean;
  bookmarksOnly: boolean;
  history: any;
  className?: any;
  competitionListNumberLiveEvents?: number;
  type: string;
  disableFilterTab?: boolean;
  checkClickEvent: (...args: Array<any>) => any;
  currentFavouritesCount: number;
  isCompetitionListLoading: boolean;
  stopCompetitionsPolling: (...args: Array<any>) => any;
  selectLeagues: (...args: Array<any>) => any;
};

const AsianEventsScreenHeader = (props: Props): React.JSX.Element => {
  const [tab, setTab] = useState(props.type);

  useEffect(() => {
    if (props.type !== tab) {
      setTab(props.type);
    }
  }, [props.type]);

  const handleSelectedTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }

    setTab(tabType);

    if (props.callback) {
      props.callback(tabType);
      props.history.push("/events/" + tabType.toLowerCase() + "/");
    }
  };

  const getTabs = () => {
    const numberOfLiveEvents: number =
      props.competitionListNumberLiveEvents || 0;
    return [
      {
        title: `LIVE (${numberOfLiveEvents})`,
        callback: () => handleSelectedTab(TabTypes.LIVE),
        isActive: tab === TabTypes.LIVE,
      },
      {
        //translate titles
        title: "POPULAR",
        callback: () => handleSelectedTab(TabTypes.POPULAR),
        isActive: tab === TabTypes.POPULAR,
      },
      {
        title: "ALL",
        callback: () => handleSelectedTab(TabTypes.ALL),
        isActive: tab === TabTypes.ALL,
      },
    ];
  };

  const { className, disableFilterTab, bookmarksOnly, favouritesOnly } = props;

  return (
    <div
      className={`${
        SessionHelper.isAsianRouteAndSessionView()
          ? "bookmark-search-header"
          : ""
      }`}
    >
      {/* mobile header component */}
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => (
          <div
            className={cx(
              "events-screen-header",
              {
                "events-screen-header--no-filter":
                  !bookmarksOnly && !favouritesOnly,
              },
              className
            )}
          >
            <EventsScreenHeaderMobile
              props={props}
              getTabs={getTabs}
              onClickBookmarks={props.onClickBookmarks}
              onClickFavourites={props.onClickFavourites}
              bookmarksActive={props.bookmarksActive}
              favouritesActive={props.favouritesActive}
              disableFilterTab={disableFilterTab}
              currentFavouritesCount={props.currentFavouritesCount}
              isCompetitionListLoading={props.isCompetitionListLoading}
              tabTypes={TabTypes}
            />
          </div>
        )}
      />
      {/* desktop header component */}
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => (
          <div
            className={cx(
              "asian-events-screen-header",
              {
                "asian-events-screen-header--no-filter":
                  !bookmarksOnly && !favouritesOnly,
              },
              className
            )}
            onClick={() => props.checkClickEvent()}
          >
            <EventsScreenHeaderDesktop
              props={props}
              getTabs={getTabs}
              onClickBookmarks={props.onClickBookmarks}
              onClickFavourites={props.onClickFavourites}
              bookmarksActive={props.bookmarksActive}
              favouritesActive={props.favouritesActive}
              type={props.type}
              disableFilterTab={disableFilterTab}
              currentFavouritesCount={props.currentFavouritesCount}
              isCompetitionListLoading={props.isCompetitionListLoading}
              tabTypes={TabTypes}
              stopCompetitionsPolling={props.stopCompetitionsPolling.bind(this)}
              selectLeagues={props.selectLeagues.bind(this)}
            />
          </div>
        )}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  favouritesOnly: state.competitionListModel.favouritesOnly,
  bookmarksOnly: state.asianCompetitionListFiltersModel.bookmarksOnly,
});

export default connect(mapStateToProps)(AsianEventsScreenHeader);
